import { useNavigate } from 'react-router-dom';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { Callout } from '@/shared/ui';
import { emojiToIcon } from '@/shared/utils/emojiToIcon';
import type { OverviewAttentionItem } from '../api/overviewApi';
import styles from './AttentionQueue.module.css';

interface AttentionQueueProps {
  items: OverviewAttentionItem[];
}

export function AttentionQueue({ items }: AttentionQueueProps) {
  const navigate = useNavigate();

  if (items.length === 0) {
    return (
      <Callout variant="success" icon={CheckCircle2} title="You're all caught up">
        No approvals or actions needed right now. PracticeNova is running.
      </Callout>
    );
  }

  return (
    <div className={styles.list}>
      {items.map((item) => {
        const Icon = emojiToIcon(item.icon) ?? Sparkles;
        return (
          <div key={item.id} className={styles.item}>
            <div className={styles.left}>
              <span className={styles.icon}>
                <Icon size={16} strokeWidth={1.75} aria-hidden />
              </span>
              <div>
                <div className={styles.label}>{item.label}</div>
                {item.dest && <div className={styles.dest}>{item.dest}</div>}
              </div>
            </div>
            {item.cta && (
              <button
                type="button"
                onClick={() => item.ctaHref && navigate(item.ctaHref)}
                className={styles.cta}
              >
                {item.cta}
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
